import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import axios from 'axios';
import VCalendar from 'v-calendar';
import Clipboard from 'v-clipboard';
import VueSimpleAlert from 'vue-simple-alert';
import './assets/css/animate.css';
import 'vue-select/dist/vue-select.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import lightbox from 'vlightbox';

Vue.use(lightbox);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VCalendar);
Vue.use(Clipboard);
Vue.use(VueSimpleAlert);
Vue.prototype.axios = axios;

const language = Vue.observable({ language: localStorage.getItem('language') || 'EN' });
Object.defineProperty(Vue.prototype, '$language', {
  get () {
    return language.language;
  },
  set (value) {
    language.language = value;
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
